import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import starightcut1 from "../assests/img/ProductsImages/StraightcutFrenchfries.jpg";
// import friescoated from "../assets/img/update_2/normal/friescoated.jpg";
// import friesshoestring from "../assests/img/ProductsImages/Shoestringfries1.jpg";
import patwedges from "../assets/img/update_2/normal/patwedges.png";
import alootikki from "../assets/img/update_2/normal/alootikki.png";
import pattyburger11 from "../assests/img/ProductsImages/PotatoBurgerPatty1.jpg";
import hashbrown12 from "../assests/img/ProductsImages//HashBrown.jpg";
import herbchillyburgerpatty from "../assests/img/ProductsImages/HerbandChilliBurgerPatty.jpg";

const OurSpeciaity_comp = () => {
  return (
    <div className="container">
      {/* Product 1 */}
      <section className="smiproductt-section">
        <div className="smiproductt-card p-4">
          <div className="row align-items-center">

            <div className="col-md-6">
              <h2 className="smiproductt-title text-uppercase">YUMWAY Hash Browns</h2>
              <h4 className="smiproductt-subtitle">
                The Breakfast Hug
              </h4>
              <p className="smiproductt-text">
                Crispy outside, soft inside. Made from real grated potatoes with zero preservatives.
              </p>
              <div className="smiproductt-meta">
                
                <p>
                  <strong>Cooking:</strong>
                </p>
                <ul>
                  <li>Deep Fry: 175°C | 3.5 mins</li>
                  <li>Air Fry: 180°C | 12 mins</li>
                  <li>Bake: 200°C | 15 mins</li>
                  <li>No preservatives</li>
                </ul>
                <br/>
              <p className="smiproductt-text">
                <b>Why Moms Love It:</b> Quick, safe, and pairs well with everything from eggs to ketchup.
              </p>                
              </div>
              {/* <button className="smiproductt-btn">Enquire Now</button> */}
            </div>
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={hashbrown12}
                alt="YUMWAY Hash Browns"
                className="smiproductt-img"
              />
            </div>            
          </div>
        </div>
      </section>


      <section className="smiproductt-section">
        <div className="smiproductt-card p-4">
          <div className="row align-items-center flex-md-row-reverse">
    
            <div className="col-md-6">
              <h2 className="smiproductt-title text-uppercase">YUMWAY CLASSIC PATTY WITH HERBS & CHILLI</h2>
              <h4 className="smiproductt-subtitle">Comfort food with a touch of spice.</h4>
              <p className="smiproductt-text">
                Crispy Potato Patties filled with fresh aromatic herbs and chilli that give a richer taste.
              </p>
              <div className="smiproductt-meta">
               
                <p>
                  <strong>Cooking:</strong>
                </p>
                <ul>
                  <li>Deep Fry: 175°C | 3.5 mins</li>
                  <li>Air Fry: 180°C | 12 mins</li>
                  <li>Bake: 200°C | 15 mins</li>
                </ul>
                <br/>
                <p>
                  <strong>Why Moms Love It:</strong>Comforting herbs, a gentle chilli kick, and homestyle goodness in every bite.
                </p>                 
              </div>
              {/* <button className="smiproductt-btn">Enquire Now</button> */}
            </div>
          <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={herbchillyburgerpatty}
                alt="herbchillyburgerpatty"
                className="smiproductt-img"
              />
            </div>            
          </div>
        </div>
      </section>

      {/* Product 3 */}
      <section className="smiproductt-section mb-5 pb-5">
        <div className="smiproductt-card p-4">
          <div className="row align-items-center">

            <div className="col-md-6">
              <h2 className="smiproductt-title text-uppercase">YUMWAY Veg Burger Patty</h2>
              <h4 className="smiproductt-subtitle">
                Stacked With Love
              </h4>
              <p className="smiproductt-text">
                Lightly spiced, moist, and made with real potatoes. Ideal for home burgers, sliders, and tiffin sandwiches.
              </p>
              <div className="smiproductt-meta">
               
                <p>
                  <strong>Cooking:</strong>
                </p>
                <ul>
                  <li>Deep Fry: 175°C | 3.5 mins</li>
                  <li>Air Fry: 180°C | 12 mins</li>
                  <li>Bake: 200°C | 15 mins</li>
                </ul>
                <br/>
                <p>
                  <strong>Why Moms Love It:</strong>Comforting herbs, a gentle chilli kick, and homestyle goodness in every bite.
                </p>                 
              </div>
              {/* <button className="smiproductt-btn">Enquire Now</button> */}
            </div>
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={pattyburger11}
                alt="pattyburger11"
                className="smiproductt-img"
              />
            </div>            
          </div>
        </div>
      </section>





      <section className="smiproductt-section">
        <div className="smiproductt-card p-4">
          <div className="row align-items-center flex-md-row-reverse">
    
            <div className="col-md-6">
              <h2 className="smiproductt-title text-uppercase">YUMWAY Aloo Tikki</h2>
              <h4 className="smiproductt-subtitle">The Street-Style Favourite — Cleaned Up.</h4>
              <p className="smiproductt-text">
                For chaats, wraps, or solo snack cravings. Loved by both moms and nostalgic millennials.
              </p>
              <div className="smiproductt-meta">
               
                <p>
                  <strong>Cooking:</strong>
                </p>
                <ul>
                  <li>Deep Fry: 180°C | 2.5-3 mins</li>
                  <li>Air Fry: 180°C | 10 mins</li>
                  <li>Bake: 200°C | 12-15 mins</li>
                </ul>
                <br/>
                <p>
                  <strong>Why Moms Love It:</strong>Great for evening snacking, party starters, and quick Indian-style meals.
                </p>                 
              </div>
              {/* <button className="smiproductt-btn">Enquire Now</button> */}
            </div>
          <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={alootikki}
                alt="herbchillyburgerpatty"
                className="smiproductt-img"
              />
            </div>            
          </div>
        </div>
      </section>    

      <section className="smiproductt-section">
        <div className="smiproductt-card p-4">
          <div className="row align-items-center">

            <div className="col-md-6">
              <h2 className="smiproductt-title text-uppercase">YUMWAY Potato Wedges</h2>
              <h4 className="smiproductt-subtitle">
                Rustic. Bold. Crowd-Pleasing.
              </h4>
              <p className="smiproductt-text">
                For sharing platters, grilled mains, and hearty snacks. Flavourful and thick-cut with no skin.
              </p>
              <div className="smiproductt-meta">
                
                <p>
                  <strong>Cooking:</strong>
                </p>
                <ul>
                  <li>Deep Fry: 180°C | 3.5 mins</li>
                  <li>Air Fry: 180°C | 12-14 mins</li>
                  <li>Bake: 200°C | 15 mins</li>
                </ul>
                <br/>
                <p>
                  <strong>Why Moms Love It:</strong>Great for evening snacking, party starters, and quick Indian-style meals.
                </p>              
              </div>
              {/* <button className="smiproductt-btn">Enquire Now</button> */}
            </div>
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={patwedges}
                alt="YUMWAY Hash Browns"
                className="smiproductt-img"
              />
            </div>            
          </div>
        </div>
      </section>        
      {/* ✅ styled-jsx CSS inside component */}
      <style jsx>{`

        .smiproductt-section {
          padding: 20px 20px;
        }
        .smiproductt-card {
          background: #fff;
          border-radius: 15px;
          box-shadow: 0 6px 6px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .smiproductt-card:hover {
          // transform: translateY(-6px);
          // box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
        }
        .smiproductt-img {
          width: 100%;
          height: auto;
          border-radius: 12px;
          transition: transform 0.3s ease;
        }
        .smiproductt-img:hover {
          transform: scale(1.05);
        }
        .smiproductt-title {
          font-size: 1.9rem;
          font-weight: 700;
          color: #f0b323;
          margin-bottom: 10px;
        }
        .smiproductt-subtitle {
          font-size: 1.5rem;
          font-weight: 600;
          color: #0f1138;
          margin-bottom: 20px;
        }
        .smiproductt-text {
          font-size: 1rem;
          color: #555;
          margin-bottom: 20px;
        }
        .smiproductt-meta {
          background: #f0b3231c;
          border-left: 5px solid #f0b323;
          padding: 15px 20px;
          border-radius: 8px;
          font-size: 0.95rem;
          margin-bottom: 20px;
        }
        .smiproductt-meta ul {
          margin: 0;
          padding-left: 18px;
        }
        .smiproductt-btn {
          background: #e67e22;
          border: none;
          color: #fff;
          font-weight: 600;
          padding: 10px 22px;
          border-radius: 8px;
          transition: background 0.3s ease;
        }
        .smiproductt-btn:hover {
          background: #d35400;
          color: #fff;
        }
        @media (max-width: 767px) {
          .smiproductt-title {
            font-size: 1.6rem;
          }
          .smiproductt-subtitle {
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default OurSpeciaity_comp;
